import { TextAlignRightIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const AlignRight = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <TextAlignRightIcon {...rest} size={Sizes[size]} color={fill} />;
};

AlignRight.displayName = 'AlignRight';
